import { render, staticRenderFns } from "./winBidding.vue?vue&type=template&id=24e158a3&scoped=true"
import script from "./winBidding.vue?vue&type=script&lang=js"
export * from "./winBidding.vue?vue&type=script&lang=js"
import style0 from "./winBidding.vue?vue&type=style&index=0&id=24e158a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e158a3",
  null
  
)

export default component.exports